import React, { useEffect, useState } from "react";
import ADADirections from "Components/ADADirections";
import { calculateDirections } from "../../map/coordinates_v3";

interface Props {
  combinedStops: {
    id: number;
    title: string;
    realLat: number;
    realLng: number;
  }[];
}

const ADADirectionsContainer = (props: Props) => {
  const { combinedStops } = props;

  const [startId, setStartId] = useState<number>(0);
  const [endId, setEndId] = useState<number>(0);
  const [instructions, setInstructions] = useState<string[]>([]);

  useEffect(() => {
    if (startId === endId) {
      setInstructions([]);
    }
    if (startId !== 0 && endId !== 0 && startId !== endId) {
      const startStop = combinedStops.filter(
        (stop) => stop.id === Number(startId)
      );
      const endStop = combinedStops.filter((stop) => stop.id === Number(endId));
      const pathCb = (paths: any, steps: any) => setInstructions(steps);

      const startLatLng = new window.google.maps.LatLng(
        startStop[0].realLat,
        startStop[0].realLng
      );
      const endLatLng = new window.google.maps.LatLng(
        endStop[0].realLat,
        endStop[0].realLng
      );

      calculateDirections(startLatLng, [], endLatLng, pathCb, pathCb);
    }
  }, [startId, endId, combinedStops]);

  return (
    <ADADirections
      combinedStops={combinedStops}
      instructions={instructions}
      setStartId={setStartId}
      setEndId={setEndId}
    />
  );
};

export default ADADirectionsContainer;
try {
    // @ts-ignore
    ADADirections.displayName = "ADADirections";
    // @ts-ignore
    ADADirections.__docgenInfo = { "description": "", "displayName": "ADADirections", "props": { "combinedStops": { "defaultValue": null, "description": "", "name": "combinedStops", "required": true, "type": { "name": "{ id: number; title: string; realLat: number; realLng: number; }[]" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/ADADirections/ADADirections.tsx#ADADirections"] = { docgenInfo: ADADirections.__docgenInfo, name: "ADADirections", path: "src/shared/containers/ADADirections/ADADirections.tsx#ADADirections" };
}
catch (__react_docgen_typescript_loader_error) { }